var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.11,
    height: 13,
    viewBox: "0 0 25.11 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12116",
    "data-name": "Group 12116",
    transform: "translate(10219.553 3403.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20177",
    "data-name": "Path 20177",
    d: "M28.9,46.887,23.131,40.9a.482.482,0,0,1,0-.665.44.44,0,0,1,.64,0l5.13,5.327L39.045,35.024a.44.44,0,0,1,.64,0,.482.482,0,0,1,0,.664Z",
    transform: "translate(-10241.996 -3437.886)",
    fill: "#f79c00",
    stroke: "#f79c00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20178",
    "data-name": "Path 20178",
    d: "M54.735,35.024a.44.44,0,0,0-.64,0L43.951,45.558,42,43.531l-.64.665,2.593,2.691,10.785-11.2A.482.482,0,0,0,54.735,35.024Z",
    transform: "translate(-10249.865 -3437.886)",
    fill: "#f79c00",
    stroke: "#f79c00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTick);
export default __webpack_public_path__ + "static/media/double-tick.962064975596dd36e99a844b9cf2ffad.svg";
export { ForwardRef as ReactComponent };